<template>
    <div class="content-list">
        <span class="subtitle middle-sidebar-title is-5 has-text-weight-bold">
            <i @click="$emit('toggle_content_list')"
               class="icon fas fa-times close has-text-grey pointer"></i> &nbsp;
            Table of Content
        </span><br/><br/>

        <!--TODO: show empty list hint-->
        <div
            v-for="item in headings"
            :key="item.id"
            :class="level_class(item)"
            class="content-heading">

            <b @click.prevent="go_to(item)" class="pointer">{{item.textContent}}</b>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoteDetailsContentsList',
    props: ['headings', 'content_ref'],
    methods: {
        go_to(item) {
            this.content_ref.scrollTop = item.offsetTop - 50;
        },
        level_class(item) {
            return { H1: 'list-item', H2: 'level-2', H3: 'level-3' }[item.tagName];
        },
    },
};
</script>

<style scoped>
    .content-list {
        width: 25rem;
    }

    .content-heading {
        padding: 0.4rem;
        margin-bottom: 0.2rem;
    }

    .level-2 {
        padding-left: 1rem;
    }

    .level-3 {
        padding-left: 2rem;
    }
</style>
